<template>
  <div class="addKeepPage">
    <van-cell-group class="baseNone beizhu">
      <van-field
        v-model="baseData.content"
        rows="3"
        autosize
        type="textarea"
        placeholder="分享新鲜事..."
      />
    </van-cell-group>
    <div class="uploadBox">
      <div class="clearfix">
        <ul class="fl clearfix">
          <li v-for="(item, index) in baseData.imgs" :key="index" class="fl">
            <div class="upload">
              <van-image
                width="100%"
                height="100%"
                fit="cover"
                :src="item"
                @click="seeImg(baseData.imgs, index)"
              />
              <van-icon name="close" @click="delImg(index)" class="delImgBtn" />
            </div>
          </li>
        </ul>
        <ul class="fl" v-if="baseData.imgs.length < 9">
          <li @click="getImgs">
            <div class="upload">
              <i
                class="van-icon van-icon-photograph van-uploader__upload-icon"
              ></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btnBox">
      <van-button
        type="info"
        :loading="btnLoading"
        loading-text="保存中..."
        @click="saveAwser"
        class="btn"
        >提交</van-button
      >
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { Showswiper } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "addKeepRecord",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      baseData: {
        content: "",
        imgs: [],
        title: "",
      },
      btnLoading: false,

      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    window.setFile = this.setFiles; //app返回附件回调
    window.addPage = this.addDocketPage;

    this.setShowLoad(false);
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    //请求App上传图片
    getImgs() {
      let _this = this;
      if (_this.clientType == "android") {
        window.android.getInfo(101);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("1");
      }
    },
    setFiles(data) {
      //App回调添加上传文件

      if (this.clientType == "android") {
        this.baseData.imgs.push(data.url);
      } else {
        let cc = JSON.parse(data);
        this.baseData.imgs.push(cc.url);
      }
    },

    delImg(index) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否确认删除图片",
        })
        .then(() => {
          let imgsList = this.baseData.imgs; //.splice(index, 1)
          imgsList.splice(index, 1);
          this.$set(this.baseData, "imgs", "");
          if (imgsList.length > 0) {
            this.$set(this.baseData, "imgs", imgsList);
          } else {
            this.$set(this.baseData, "imgs", []);
          }
        });
    },

    seeImg(item, img) {
      // let document_W = document.body.clientWidth || document.body.offsetWidth;
      let newItemArr = [];
      item.forEach((imgItem) => {
        newItemArr.push(imgItem + "?x-oss-process=image/resize,p_50");
      });
      Showswiper(newItemArr, img);
    },

    saveAwser() {
      let _this = this;
      if (_this.baseData.content == "") {
        _this.$toast("分享内容不能为空！");
      } else {
        _this.btnLoading = true;
        _this.$api.userCenter.user
          .saveNote(_this.baseData)
          .then((res) => {
            if (res.code == "1") {
              let text = "分享成功！";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            console.log(err, "err");
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.addKeepPage {
  width: 100%;
  height: 100%;
  padding: 20px 16px;

  .baseNone::after {
    content: none;
  }
  .baseNone.beizhu {
    min-height: 80px;
  }
  .uploadBox {
    margin-top: 20px;
    .upload {
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -webkit-align-items: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      box-sizing: border-box;
      width: 65px;
      height: 65px;
      margin: 0 8px 8px 0;
      background-color: #f7f8fa;
      border-radius: 8px;
      .van-image {
        width: 65px;
        height: 65px;
      }
      .delImgBtn {
        font-size: 14px;
        color: red;
        position: absolute;
        top: -5px;
        right: -5px;
        z-index: 555;
      }
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
}
</style>
 